import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class H5OverLay extends Vue {
    @Prop() public value!: boolean
    public click() {
        this.$emit('click', false)
    }
}